/* eslint-disable no-param-reassign,no-underscore-dangle,@typescript-eslint/no-unused-vars */

xplenty.service('connectionTypesService', [
  'ConnectionTypes',
  'notify',
  function (ConnectionTypes, notify) {
    let queryCache = null;
    const helpCache = {};

    return {
      loaded: false,

      query(cb) {
        const _this = this;
        if (queryCache) return cb(queryCache);

        return ConnectionTypes.query().subscribe(
          function (data) {
            // TODO: remove this
            // temporary fix because server error
            _.each(data, function (connectionType) {
              _.each(connectionType.groups, function (group) {
                if (
                  group.group_name ===
                  '<span class="translation_missing" title="translation missing: en-US.database_connection.type_group.services">Services</span>'
                ) {
                  group.group_name = 'Services';
                }
              });
            });
            //
            queryCache = data;
            cb(queryCache);
            _this.loaded = true;
          },
          () => {
            notify.error(null, 'Failed to load connection types');
          },
        );
      },

      help(connectionType, cb) {
        if (helpCache[connectionType]) return cb(helpCache[connectionType]);

        return ConnectionTypes.query({
          connection_type: connectionType,
        }).subscribe(
          function (data) {
            helpCache[connectionType] = data;
            cb(helpCache[connectionType]);
          },
          () => {
            notify.error(null, 'Failed to load connection types');
          },
        );
      },
    };
  },
]);
